import React, { useEffect } from 'react';
import { KFLButton, KFLDialog } from '@kamstrup/kamstrup-frontend-library';
import DialogHeader from '../../shared/dialog/dialogHeader';
import Translate from '../../shared/localization/localize';
import DialogSection from '../../shared/dialog/dialogSection';
import {
  TransferDialogs,
  TransferStatus,
} from '../../../modules/dialogs/transfer';
import DialogFooter from '../../shared/dialog/dialogFooter';
import UserDetailsForm from '../../shared/userInfoRetriever/userDetailsForm';
import { TxInfoIcon } from './transferSummary';
import * as m from '../../../modules/dialogs/transfer/messages';
import { useTxSend } from '../../../modules/dialogs/transfer/useTxSend';
import useDevices from '../../devicesPage/useDevices';
import { parseKeys } from '../../../modules/devices';
import useLocale from '../../../hooks/useLocale';
import Ellipsis from '../../shared/ellipsis';

const TxDialogSend: React.FC = () => {
  const { translate } = useLocale();
  const { selectedKeys } = useDevices();
  const {
    tx,
    useReceiver,
    setStatus,
    reset,
    showTxDevices,
    setTxDevices,
    closePanel,
    changeScreen,
  } = useTxSend();
  const receiver = tx.receiver;

  useEffect(() => {
    tx.status === TransferStatus.COMPLETED
      ? reset()
      : setStatus(TransferStatus.NOT_VALIDATED);
  }, [tx.status]);

  useEffect(() => {
    setTxDevices(parseKeys(selectedKeys));
  }, [selectedKeys.length]);

  const numDevices = selectedKeys?.length || 0;
  const content = (
    <>
      <DialogSection>
        <div className="tx_send_sel_box">
          <div className="tx_send_sel_header">
            <span className="tx_send_sel_label">{translate(m.msgSelected)}</span>
            <TxInfoIcon {...tx}></TxInfoIcon>
          </div>
          <KFLButton
            onClick={() => showTxDevices()}
            variant="borderless"
            disabled={numDevices === 0}
          >
            {translate(m.msgDevice(numDevices))}
          </KFLButton>
        </div>
      </DialogSection>
      <DialogSection isMain scrollable>
        <div className="tx_send_customer_box">
          <div className="tx_send_customer_label">{translate(m.msgSentTo)}</div>
          <div className="tx_send_customer_selected">
            <Ellipsis>{tx.receiver?.customer?.customerName}</Ellipsis>
          </div>
        </div>
        <UserDetailsForm id="dg-transfer-send-receiver" {...useReceiver} hideDetails />
      </DialogSection>
    </>
  );

  const isReady = numDevices > 0 && receiver.customer?.customerId;
  const nextButton = (
    <KFLButton
      id="dg-tx-send-bt-next"
      key="dg-tx-send-bt-next"
      onClick={() => changeScreen(TransferDialogs.SEND_VALIDATE)}
      disabled={!isReady}
    >
      {translate(m.msgContinueBtn)}
    </KFLButton>
  );

  return (
    <KFLDialog
      header={
        <DialogHeader
          title={<Translate message={m.msgHeaderSend} />}
          fnCloseDialog={closePanel}
        />
      }
      sections={[content]}
      footer={
        <DialogFooter buttons={[nextButton]} fnCloseDialog={closePanel} />
      }
    />
  );
};

export default TxDialogSend;
